import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading-icon.html',
  styleUrls: ['./loading-icon.component.scss']
})
export class LoadingIconComponent {

}
